export default __webpack_public_path__ + "static/media/cybernetics.890e54ac.jpg";